import { ArrowDownRight01Icon, ArrowRight02Icon, ArrowUpRight01Icon } from '@hugeicons/core-free-icons';
import { Icon } from '../primitives/icon.js';
import * as React from 'react';
import { cn } from '../../lib/cn.js';
import { EMPTY } from '../../lib/format.js';
import { Skeleton } from '../primitives/states.js';

export interface MetricStatProps {
  label: string;
  /** Preformatted value; null = unknown (shows "—" + "Sin datos", never 0). */
  value: string | number | null;
  /** Denominator / definition, e.g. "de 128 prospectos elegibles". */
  hint?: string;
  delta?: { label: string; direction: 'up' | 'down' | 'flat'; /** Whether the change is good. */ positive?: boolean };
  loading?: boolean;
  className?: string;
}

/** Compact metric (not an oversized tile). */
export const MetricStat = React.forwardRef<HTMLDivElement, MetricStatProps>(function MetricStat({ label, value, hint, delta, loading, className }, ref) {
  const deltaIcon = delta?.direction === 'up' ? ArrowUpRight01Icon : delta?.direction === 'down' ? ArrowDownRight01Icon : ArrowRight02Icon;
  return (
    <div ref={ref} className={cn('grid gap-1 rounded-card border border-border-subtle bg-surface-default px-4 py-3', className)}>
      <span className="text-meta font-medium text-text-secondary">{label}</span>
      {loading ? (
        <Skeleton label={`Cargando ${label}`} className="h-7 w-20" />
      ) : (
        <span className="flex flex-wrap items-baseline gap-x-2">
          <span className="ef-tabular text-section font-semibold text-text-primary">{value === null ? EMPTY : value}</span>
          {value === null ? <span className="text-meta text-text-secondary">Sin datos</span> : null}
          {delta ? (
            <span
              className={cn(
                'inline-flex items-center gap-0.5 text-meta font-medium',
                delta.positive === undefined ? 'text-text-secondary' : delta.positive ? 'text-success' : 'text-danger',
              )}
            >
              <Icon icon={deltaIcon} className="size-3.5" />
              {delta.label}
            </span>
          ) : null}
        </span>
      )}
      {hint ? <span className="text-meta text-text-secondary">{hint}</span> : null}
    </div>
  );
});
